import { deepCopy } from '@angular-devkit/core/src/utils/object';
import { Component, Input, OnInit, OnChanges, SimpleChange, Output, EventEmitter, HostBinding } from '@angular/core';
import { DateToString } from 'src/app/core/pipe/pipe-date';
import { ConditionsService } from 'src/app/shared/services/conditions.service';
import { GeneralService } from 'src/app/shared/services/general.service';


@Component({
    selector: 'conditions',
    templateUrl: './conditions.component.html',
    styleUrls: ['./conditions.component.scss']
})
export class ConditionsComponent implements OnInit, OnChanges {

    @Input() data : any;
    @Input() selected : any = null;
    @Input() unique : Boolean = false;
    @Input() template : any = 'unit';
    @HostBinding('className') className = '';

    @Input()
    set condition(val: any) {
        if(typeof val == 'number')
            this.setConditionSelected(this.conditions.filter(item => item.id == val)[0]);
        else
            this.setConditionSelected(val);
    }
    get files() {
      return this.conditionSelected;
    }
    @Output() conditionSel = new EventEmitter();

    conditionSelected : any = null;
    selectedUnit : any = [];
    conditions : any = [];
    conditionsColMax = 0;

    init = false;
    

    dateOptions = { 
        day: '2-digit',
        month: 'short',
        year: '2-digit'
      };

    constructor( protected gs : GeneralService,
        protected cs : ConditionsService
    ){
    }
    
    
    ngOnInit(){
        this.className = 'template-'+this.template;
    }

    setDefault(){
        this.init = false;
        
        if(!this.data?.conditions)
            return;
        
        let dateToString = new DateToString();
        let amountCalc = this.selectedUnit?.amount;
        this.conditions = deepCopy(this.data.conditions);

        if(this.template!='print-amount' || this.selectedUnit.status == 11){
            this.conditions = this.cs.calculate(amountCalc , this.conditions, this.selected, this.selectedUnit);
            this.conditionsColMax = this.cs.conditionsColMax;
        }

        // if(this.template!='print-amount' || this.selectedUnit.status == 11)
        // this.conditions = this.conditions
        //     .filter(item => {
                    
        //         return (!item?.validUntil || new Date(item.validUntil)>=new Date())
        //             && (   !this.selectedUnit
        //                 || this.selected == 'all' 
        //                 || !item?.restricted 
        //                 || (item?.applyBlocks && this.selectedUnit?.blockId && item.applyBlocks.indexOf(this.selectedUnit.blockId) > -1)
        //                 || (item?.applyUnitTypes && this.selectedUnit?.blockTypeId && item.applyUnitTypes.indexOf(this.selectedUnit.blockTypeId) > -1)
        //                 || (item?.applyUnits && this.selectedUnit?.id && item.applyUnits.indexOf(this.selectedUnit.id) > -1)
        //             );
        //     })
        //     .map(item => {
            
        //         if(item?.validUntil){
        //             item.validUntilStr = dateToString.transform(item.validUntil,this.dateOptions);
        //         }
            

        //         item.conditionFixed = 0;
        //         item.amountReduce = 0;
        //         item.condition = this.getConditionList(item.condition);
                
        //         let nC ={};
        //         let balancePercentage = 0;
        //         let amountTotal = 0;
        //         let amount = amountCalc;

        //         item.condition
        //         .sort((a,b) => a?.attr?.sort - b?.attr?.sort)
        //         .map(cond => {

        //             if(cond.attr.quantity && !cond.quantity && cond.tag_id != '136')
        //                 return;

        //             cond.percentage = this.gs.convertMoneyToDouble(cond.percentage);
        //             cond.amount = this.gs.convertMoneyToDouble(cond.amount);

                    
        //             if(cond.tag_id == '136' && balancePercentage){
                    
        //                 if(!cond.percentage)
        //                     cond.percentage = 0;

        //                 cond.percentage -= balancePercentage;
        //             }
                    
        //             if(!cond.fixed){
        //                 cond.amountTotal = amount * (cond.percentage / 100) * (cond?.attr?.operation || 1);
        //                 cond.amountDiv = cond.amountTotal / (cond.quantity || 1);
        //             } else {
        //                 cond.amountTotal = cond.amount * (cond.quantity || 1) * (cond?.attr?.operation || 1);
        //                 cond.amountDiv = cond.amount;
        //                 cond.percentage = (cond.amountTotal * 100 / amount) * (cond?.attr?.operation || 1);

        //             if(cond?.attr?.operation != -1)
        //                 balancePercentage += cond.percentage;
        //             }

        //             amountTotal +=cond.amountTotal;

        //             cond.percentage = this.gs.convertMoneyToDouble(cond.percentage);

        //             if(cond.amountTotal < 0)
        //                 item.amountReduce += cond.amountTotal;                    

        //             return cond;

        //         });

        //         if(item.condition.length + (item.amountReduce < 0? 1 : 0) > this.conditionsColMax){
        //             this.conditionsColMax = item.condition.length + (item.amountReduce < 0? 1 : 0);
        //         }

        //         item.amountCalc = amountCalc - item.conditionFixed;
        //         item.amountTotal = item.amountCalc + item.amountReduce;
                        
                
        //         return item;

        //     })
            
        //     .filter(Boolean) || [];

        if(!this.conditionSelected && !!this.conditions.length){
            this.conditionSelected = this.conditions[0];
        }

        if(this.conditionSelected)
            this.setConditionSelected(this.conditionSelected);

        this.init = true;
    }

    ngOnChanges(changes: { [key: string]: SimpleChange }) {
        if(changes?.selected){
            if(this.template=='unit')
                this.conditionSelected = null;

            this.selectedUnit = changes.selected.currentValue;
            this.setDefault();
        }
    }

    setConditionSelected(ev){
        //if(!ev)            return;
            
        this.conditionSelected = ev?.value || ev;
        this.conditionSel.emit(ev?.value || ev);
    }

    getConditionList(data){

        let nData = [];
    
        for (const field in data){
          let part = field.split('_');
          let nf = {};
              nf[part[0]] = data[field];
    
          nData[part[1]] = typeof nData[part[1]] == 'undefined'? {...nf,...this.gs.getTags('conditionType', false, part[1])}
                                                               : {...nData[part[1]], ...nf};
        }
        return nData.filter(item=> item?.active).filter(Boolean).sort((a,b) => a?.attr?.priority - b?.attr?.priority);
      }

    compareFn(c1: any, c2: any): boolean {
        if(c2 === null)
          return false;
    
        return c1 == c2;
      }
}